// Components==============
import Checkbox from 'components/UI/Checkbox';
import { motion } from 'framer-motion';
import React from 'react';
import './index.module.scss';
// =========================

export function TextInput({
    type = 'text',
    label,
    name,
    value,
    onChange,
    required = true,
}) {
    return (
        <>
            <label>{label}</label>
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                styleName="text-input"
                required={required}
            />
        </>
    );
}

export function TextAreaInput({
    label,
    name,
    value,
    onChange,
    required = true,
}) {
    return (
        <>
            <label>{label}</label>
            <textarea
                name={name}
                value={value}
                onChange={onChange}
                styleName="text-area-input"
                required={required}
            />
        </>
    );
}

export function Options({ options, label, setSelected, selected }) {
    function handleClick(option) {
        const exists = selected.find((current) => current === option);

        if (!exists)
            return setSelected((prev) => ({
                ...prev,
                to: [...prev.to, option],
            }));

        setSelected((prev) => ({
            ...prev,
            to: prev.to.filter((current) => current !== option),
        }));
    }

    return (
        <div styleName="options">
            <label>{label}</label>
            <div styleName="wrapper">
                {options.map((option) => {
                    const isSelected = selected.find((e) => e === option);

                    return (
                        <motion.div
                            key={option}
                            styleName="option"
                            onClick={() => handleClick(option)}
                        >
                            <Checkbox isSelected={isSelected} />
                            <motion.p
                                animate={{
                                    color: isSelected ? '#1e265c' : '#707070',
                                }}
                                initial={{ color: '#707070' }}
                                whileHover={{ x: 2 }}
                            >
                                {option}
                            </motion.p>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    );
}
